import { Card } from '@/components/design-system/Card';
import { Skeleton } from '@/components/design-system/Skeleton';

export const ProductCardSkeleton = () => (
  <Card className="mb-4 rounded-xl p-5 flex gap-4 justify-between bg-white">
    <div className="flex flex-col gap-4 flex-1">
      <div className="flex items-center">
        <Skeleton className="h-12 w-12 rounded flex-shrink-0" />
        <div className="flex flex-col pl-2 gap-2 flex-1">
          <Skeleton className="h-6 w-40 rounded" />
          <Skeleton className="h-4 w-28 rounded" />
        </div>
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-full rounded" />
        <Skeleton className="h-4 w-full rounded" />
        <Skeleton className="h-4 w-full rounded" />
      </div>
    </div>
    <div>
      <Skeleton className="size-6 rounded-md" />
    </div>
  </Card>
);
